"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkForDuplicates = exports.convertToMembershipInterface = exports.convertToGroupInterface = void 0;
const convertToGroupInterface = (groupDto) => {
    return {
        name: groupDto.name,
        avatar: groupDto.image || '',
        founder: groupDto.founder_id,
        identifier: groupDto.id,
        isFounder: groupDto.is_founder,
        isAdmin: groupDto.is_admin,
        isReadonly: groupDto.is_readonly,
        quizzesCount: groupDto.content_counts.quiz,
        lecturesCount: groupDto.content_counts.lecture,
        recordingsCount: groupDto.content_counts.video,
        questionsCount: groupDto.content_counts.question,
        coursesCount: groupDto.content_counts.course,
        membersCount: groupDto.content_counts.membership,
        members: [],
        screensCount: groupDto.content_counts.plate,
        information: groupDto.description,
        lastActivityTime: +Date.parse(groupDto.activity_timestamp),
        /**
         * 169 is Atlas group
         */
        canLeave: !groupDto.is_automembership && groupDto.id !== 169,
    };
};
exports.convertToGroupInterface = convertToGroupInterface;
const convertToMembershipInterface = (membershipDto) => {
    return {
        name: membershipDto.to_user.username,
        avatar: membershipDto.to_user.image,
        userIdentifier: membershipDto.to_user.id,
        identifier: membershipDto.id,
        isAdmin: membershipDto.admin,
        status: membershipDto.status,
        isFounder: false, // TODO: Update calculation logic
    };
};
exports.convertToMembershipInterface = convertToMembershipInterface;
const checkForDuplicates = (groupMembers = [], members) => {
    let memberships = [...groupMembers];
    const memberIds = new Set();
    if (!memberships.length)
        memberships = members;
    else {
        memberships.forEach(member => memberIds.add(member.identifier));
        const uniqueMembers = members.reduce((acc, member) => {
            if (memberIds.has(member.identifier)) {
                const memberIndex = memberships.findIndex(({ identifier }) => identifier === member.identifier);
                memberships.splice(memberIndex, 1);
                return [...acc, member];
            }
            memberIds.add(member.identifier);
            return [...acc, member];
        }, []);
        memberships = [...memberships, ...uniqueMembers];
    }
    return memberships;
};
exports.checkForDuplicates = checkForDuplicates;
